import { render } from "./ModalAchievements.vue?vue&type=template&id=2e991525&scoped=true"
import script from "./ModalAchievements.vue?vue&type=script&lang=js"
export * from "./ModalAchievements.vue?vue&type=script&lang=js"

import "./ModalAchievements.vue?vue&type=style&index=0&id=2e991525&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e991525"

export default script